module.exports = __webpack_public_path__ + "static/img/ikonaScratchStart-ON.b3730aab.png";